<template>
  <!-- DETAIL ZARIZENI -->
  <div class="detail-page">
    <div
      v-if="simcard"
      :class="{ visible: isHeaderFixed }"
      class="detail-page__sticky-header d-flex align-items-center"
    >
      <div class="detail-page__sticky-header__left d-flex">
        <strong class="detail-page__sticky-header__name">
          {{ $filters.strLimit(simcard.friendlyName, 8) }}
        </strong>
        <div class="d-flex align-items-center">
          <div v-if="simcard.status === 'ACTIVE'" class="atom-circle atom-circle--success">A</div>
          <div v-else-if="simcard.status === 'OTHER'" class="atom-circle atom-circle--warning">O</div>
          <div v-else-if="simcard.status === 'PENDING_ACTIVATION'" class="atom-circle atom-circle--warning">P</div>
          <div v-else-if="simcard.status === 'SUSPENDED'" class="atom-circle atom-circle--gray">S</div>
        </div>
      </div>
      <div class="detail-page__sticky-header__right d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <div :class="{ active: selectedTab === 4 }" class="detail-page__tabs__tab" @click="selectedTab = 4">
            {{ $t("vseOZarizeni") }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="simcard" id="detail-header" class="layout__content__header layout__content__header--white">
      <AppBack :route="{ name: 'simcards', params: { customerId, projectId } }" :text="'naSeznamZarizeni'" />
      <div class="d-flex justify-content-between mb-3 mb-md-5">
        <h1 v-if="simcard.friendlyName?.length > 0" class="mb-0 layout__content__header__title">
          {{ simcard?.friendlyName }}
        </h1>
        <h1 v-else class="mb-0 layout__content__header__title">
          {{ simcard?.iccid }}
        </h1>

        <div class="layout__content__header__buttons d-none d-md-flex justify-content-end align-items-end">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditSimcardModal('editItem')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
        </div>
      </div>
      <div class="detail-page__info d-flex align-items-center font-weight-light">
        <span v-if="simcard" class="detail-page__info__item">
          {{ simcard?.iccid }}
        </span>
        <span class="detail-page__info__item">SIM</span>
      </div>
      <div v-if="simcard" class="detail-page__boxes d-flex flex-column flex-md-row">
        <!-- SERVICE BOX -->
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $filters.firstUpper($t("sluzba")) }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="atom-icon justify-content-start">
              <img src="@/assets/icons/sluzba-check.svg" />
            </div>
            <span v-if="service" class="detail-page__boxes__item__textDashed">
              {{ service.custServiceName }}
            </span>
            <AppLoader v-if="this.serviceLoading" />
          </div>
        </div>
      </div>
    </div>

    <div class="layout__content__content pt-0 px-0">
      <div id="tabs" class="detail-page__tabs">
        <!-- TABS -->
        <div class="detail-page__tabs__header d-flex">
          <div class="d-flex align-items-end detail-page__tabs__wrapper">
            <div :class="{ active: selectedTab == 4 }" class="detail-page__tabs__tab" @click="selectedTab = 4">
              {{ $filters.firstUpper($t("vseOZarizeni")) }}
            </div>

            <div :class="{ active: selectedTab == 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
              {{ $filters.firstUpper($t("SIMCARD_USAGE")) }}
            </div>

            <RadioOpenClose
              :radio-slides="radioSlides"
              :show="showHelp"
              @update-show-radio-help="showRadioHelp($event)"
            />
          </div>
        </div>
        <!-- TABS DETAIL -->
        <div class="detail-page__tabs__content">
          <div v-if="selectedTab == 4">
            <div class="about">
              <div v-if="simcard" class="about__section">
                <div class="about__title">
                  <strong>{{ $filters.firstUpper($t("SIM_INFO")) }}</strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("SIM_NAME")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.friendlyName }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("Rezim")) }}
                    </div>
                    <div class="about__info__value">
                      <div v-if="simcard.status == 'ACTIVE'" class="atom-circle atom-circle--success">
                        <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_ACTIVE')">A</div>
                      </div>
                      <div v-else-if="simcard.status == 'OTHER'" class="atom-circle atom-circle--warning">
                        <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_OTHER')">0</div>
                      </div>
                      <div v-else-if="simcard.status == 'PENDING_ACTIVATION'" class="atom-circle atom-circle--warning">
                        <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_PENDING_ACTIVATION')">P</div>
                      </div>
                      <div v-else-if="simcard.status == 'SUSPENDED'" class="atom-circle atom-circle--gray">
                        <div v-tooltip :title="$t('TOOLTIP_SIM_STATE_SUSPENDED')">S</div>
                      </div>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("DATA_VOLUME")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.dataVolume }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("SMS_VOLUME")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.smsVolume }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="simcard" class="about__section">
                <div class="about__title">
                  <strong>{{ $filters.firstUpper($t("sluzbaALimity")) }}</strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("sluzba")) }}
                    </div>
                    <div v-if="service" class="about__info__value">
                      {{ service.custServiceName }}
                      <br />
                      <small>{{ service.custServiceId }}</small>
                    </div>
                    <AppLoader v-if="this.serviceLoading" />
                  </div>
                </div>
              </div>
              <div v-if="simcard" class="about__section">
                <div class="about__title">
                  <strong>{{ $filters.firstUpper($t("IdentifikacniUdaje")) }}</strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("ICCID")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard?.iccid }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PHONE_NUMBER")) }}
                    </div>
                    <div class="about__info__value">+{{ simcard.msisdn }}</div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("IMSI")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.imsi }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("MCC")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.mcc }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("MNC")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.mnc }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("APN")) }}
                    </div>
                    <div class="about__info__value">iot.melita.io</div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("IP_CONFIGURATION")) }}
                    </div>
                    <div class="about__info__value">
                      <span v-if="simcard.ipConfiguration">{{ simcard.ipConfiguration.ipType }}</span>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PIN1")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.pin1 }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PIN2")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.pin2 }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PUK1")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.puk1 }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("PUK2")) }}
                    </div>
                    <div class="about__info__value">
                      {{ simcard.puk2 }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("LAST_LOCATION")) }}
                    </div>
                    <div class="about__info__value">
                      <span v-if="this.lastLocation">
                        {{ this.lastLocation }}
                      </span>
                      <span v-else>
                        <AppLoader />
                      </span>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("LAST_ACTIVITY")) }}
                    </div>
                    <div class="about__info__value">
                      <span
                        v-if="simcard.lastActivityTimestamp"
                        v-html="$filters.timestampToDateTime(simcard.lastActivityTimestamp)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedTab == 2" class="messages">
            <SimcardUsage :reload-d-m="reloadDM" :simcard="simcard" @show-usage="showUsage" />
          </div>
        </div>
      </div>
    </div>

    <EditSimcardModal
      v-if="openedEditSim.length > 0"
      :item="simcard"
      :opened="openedEditSim"
      :selected-state="simcard.status"
      @info="toggleConfirmation"
      @close-box="toggleEditSimcardModal"
      @open-box="toggleEditSimcardModal"
      @reload-items="loadSimCard"
    />
    <!-- ERRORS -->
    <div v-if="simcard">
      <div v-if="errorsToTranslate.length > 0">
        <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
      </div>
    </div>
    <InfoModal :opened="openedInfoConfirmation" :text="'SIMCARD_CHANGE_STATUS_INFO'" @close="toggleConfirmation" />

    <ShowUsageModal :item="selectedUsage" :opened="openedUsageDetail" @close-box="toggleShowUsage" />
  </div>
</template>

<script>
import axios from "axios"
import AppBack from "@/components/back.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import EditSimCardModal from "@/components/modals/simcards/edit.vue"
import AppLoader from "@/components/loader.vue"
import SimcardUsage from "@/components/simcards/simcard-usage.vue"
import InfoModal from "@/components/confirmations/info.vue"
import ShowUsageModal from "@/components/modals/simcards/usageShow.vue"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    AppBack,
    RadioOpenClose,
    ErrorModal,
    AppLoader,
    EditSimcardModal: EditSimCardModal,
    SimcardUsage,
    InfoModal,
    ShowUsageModal
  },
  props: {
    projectId: String,
    customerId: String
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return { projectStore, configStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      selectedProjectId: this.$router.currentRoute.value.params.projectId,
      selectedCustomerId: this.$router.currentRoute.value.params.customerId,
      simcardId: this.$route.params.id,
      simcard: null,
      groups: [],
      groupsEndpoints: [],
      signal: 2,
      selectedTab: 4,
      service: {},
      openedGroups: [],
      openedDropdown: false,
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      sort: "%2Dcode",
      messages: [],
      openedMessageDetail: [],
      selectedMessage: {},
      lastMessageIn: {},
      lastMessageOut: {},
      openedDeleteDevice: false,
      deleteText: "",
      openedSendMessage: [],
      openedEditSim: [],
      reloadDM: false,
      errorsToTranslate: [],
      openedError: false,
      lastLocation: "",
      serviceLoading: true,
      openedUsageDetail: [],
      allLogs: [
        {
          code: "Editace zařízení",
          level: "",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "karel.vochechule@email.muj",
          parameters: {
            userName: "Karel Vochechule"
          }
        },
        {
          code: "Konfigurační zpráva",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "jan.pavlasek@email.muj",
          parameters: {
            userName: "Jan Pavlásek"
          }
        },
        {
          code: "Vytvoření zařízení",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "mirek@email.muj",
          parameters: {
            userName: "Mirek Dušín"
          }
        }
      ],
      allMessages: [
        {
          id: "da35b8d0-7587-11ea-a6bd-81bd9b1e8c83",
          messageTime: "2020-03-15T12:33:23.000Z",
          message: {
            cmd: "gw",
            EUI: "48FFFFFFA101005B",
            ts: 1496319938065,
            fcnt: 2318,
            port: 1,
            freq: 868500000,
            toa: 370,
            dr: "SF10 BW125 4/5",
            ack: false,
            data: "kobliha",
            gws: [
              {
                rssi: -88,
                snr: -5.8,
                ts: 1496319938078,
                gweui: "B827EBFFFFE705D5",
                lat: 50.18598619999999,
                lon: 15.8135032
              }
            ]
          }
        },
        {
          id: "da35b8d0-7587-11ea-a6bd-81bd9b1e8c84",
          messageTime: "2020-02-12T12:33:23.000Z",
          message: {
            cmd: "gw",
            EUI: "48FFFFFFA101005A",
            ts: 1496319938065,
            fcnt: 2318,
            port: 5,
            freq: 868500000,
            toa: 370,
            dr: "SF10 BW125 4/5",
            ack: false,
            data: "testik",
            gws: [
              {
                rssi: -88,
                snr: -0.8,
                ts: 1496319938078,
                gweui: "B827EBFFFFE705D5",
                lat: 50.18598619999999,
                lon: 15.8135032
              }
            ]
          }
        },
        {
          id: "da35b8d0-7587-11ea-a6bd-81bd9b1e8c82",
          messageTime: "2020-03-12T12:33:23.000Z",
          message: {
            cmd: "gw",
            EUI: "48FFFFFFA101005C",
            ts: 1496319938065,
            fcnt: 2318,
            port: 3,
            freq: 868500000,
            toa: 370,
            dr: "SF10 BW125 4/5",
            ack: false,
            data: "aaaaa",
            gws: [
              {
                rssi: 2,
                snr: 1,
                ts: 1496319938078,
                gweui: "B827EBFFFFE705D5",
                lat: 50.18598619999999,
                lon: 15.8135032
              }
            ]
          }
        }
      ],
      articleLink: "",
      openedInfoConfirmation: false
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    locale() {
      return this.$i18n.locale
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    radioDisabled: {
      handler() {
        this.showHelp = !this.radioDisabled
      },
      immediate: true
    }
  },
  mounted() {
    this.loadSimCard()

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    loadSimCard() {
      var id = this.$route.params.id
      var serviceId = this.$route.params.serviceId

      axios
        .get(process.env.VUE_APP_API + "/simcards/service/" + serviceId + "/" + id, {})
        .then((result) => {
          console.log("device detail", result)
          this.simcard = result.data.data
          this.loadLastLocation()
          this.loadService()
        })
        .catch(() => {})
    },
    loadLastLocation() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/simcards/service/" +
            this.simcard.custServiceId +
            "/" +
            this.simcard.iccid +
            "/location",
          {}
        )
        .then((result) => {
          this.lastLocation = result.data.data.country
        })
        .catch(() => {})
    },
    loadService() {
      axios
        .get(process.env.VUE_APP_API + "/services/" + this.simcard.custServiceId)
        .then((result) => {
          this.service = result.data.data
          this.$store.commit("modals/setWaitingLoader", "")
          this.serviceLoading = false
        })
        .catch(() => {})
    },
    toggleEditSimcardModal(box) {
      if (this.openedEditSim.indexOf(box) > -1) {
        this.openedEditSim = []
      } else {
        this.openedEditSim.push(box)
      }
    },
    toggleShowUsage(box) {
      if (this.openedUsageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedUsageDetail = [])
          : this.openedUsageDetail.splice(this.openedUsageDetail.indexOf(box), 1)
      } else {
        this.openedUsageDetail.push(box)
      }
    },
    toggleConfirmation() {
      this.openedInfoConfirmation = this.openedInfoConfirmation ? false : true
    },
    showUsage(usage) {
      this.selectedUsage = usage
      this.openedUsageDetail.push("showUsage")
    }
  }
}
</script>

<style scoped></style>
